/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const parkSlice = createSlice({
    name: 'parkSlice',
    initialState: {
        loading: false,
        parks: [],
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setParks: (state, action) => {
            state.parks = action.payload;
        },
        setPackages: (state, action) => {
            state.parks = action.payload;
        },
    },
});
export const { setLoading, setParks, setPackages } = parkSlice.actions;

export default parkSlice.reducer;
